import React, { useRef, useEffect, useState, forwardRef, useImperativeHandle } from 'react'
import { useSelector } from 'react-redux'
// Alert, message
import { Row, Col, Input } from 'antd'
import { formatMessageNew, handleChange, languageObj } from '../../../utils/common'
import { apiTagValidation, readNfcDataForPhone, reset } from '../../../services/tag/tag'
import { modalError, destroyModal } from '../../../utils/modalUtils'

let errorModal = null
let tagTypeErrorModal = null
let intervalRef = null
// let intervalFlag = false
const labelStyle = { textAlign: 'right', display: 'flex', alignItems: 'center' }
const ReadTag = forwardRef((props, ref) => {
  const inputRef = useRef(null)
  const commonStore = useSelector(state => state.commonStore)
  const languageState = useSelector(state => state.commonStore.language)
  const macState = useSelector(state => state.commonStore.mac)
  const deviceCode = useSelector(state => state.commonStore.deviceCode)
  // const workstationState = useSelector(state => state.commonStore.workstation)
  // const [intervalFlag, setIntervalFlag] = useState(false)
  const [upcValue, setUpcValue] = useState('')
  const [nfcValue, setNfcValue] = useState('')
  const [actualTagType, setActualTagType] = useState('')
  const [upcInputReadOnly, setUpcInputReadOnly] = useState(false)

  const queryHeader = {
    isRF: true,
    mac: macState,
    deviceCode
  }

  // 页面初始化
  useEffect(() => {
    console.log('readTag初始化')
    inputRef.current.focus({ cursor: 'all' })
    // 监听全局键盘事件
    window.addEventListener('keydown', onWindowKeyDown)
    return () => {
      // 移除全局键盘事件
      window.removeEventListener('keydown', onWindowKeyDown)
      // 清除定时器
      clearInterval(intervalRef)
      resetUidFun()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // 语言切换
  useEffect(() => {
    // 防止切换语言后重复NFC报错不切换
    if (intervalRef) clearInterval(intervalRef)
    commonStore.languageObj = languageObj[languageState]
    // 启用定时器
    openNfcInterval()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [languageState])

  // NFC读取到值就校验
  useEffect(() => {
    if (nfcValue?.length !== 0) onValidationTag()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nfcValue])

  // 启用定时器 获取NFC的值
  // useEffect(() => {
  //   console.log('监听')
  //   console.log('intervalFlag', intervalFlag)
  //   // props.confirmDialogMac()
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [intervalFlag])

  // 弹出报错 upc失焦点
  useEffect(() => {
    inputRef.current.blur()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorModal])

  useImperativeHandle(ref, () => {
    return {
      clearInputs: () => {
        // 清空数据
        setUpcValue('')
        setNfcValue('')
        setActualTagType('')
        resetUidFun()
        // 获取焦点
        inputRef.current.focus({ cursor: 'all' })
      },
      inputBlur: () => {
        inputRef.current.blur()
      },
      openInterval: () => {
        openNfcInterval()
      },
      clearInterval: () => {
        clearInterval(intervalRef)
      }
    }
  })

  const resetUidFun = () => {
    reset({}, queryHeader)
      .then(res => {
        console.log(res)
      })
      .catch(error => {
        console.log(error)
      })
  }

  // 获取NFC的定时器
  const openNfcInterval = () => {
    if (props.showMacError()) return
    if (intervalRef) clearInterval(intervalRef)
    intervalRef = setInterval(() => {
      // 读取NFC
      getNfcValue()
    }, 650)
  }

  // 获取NFC
  const getNfcValue = () => {
    const params = {}
    readNfcDataForPhone(params, queryHeader)
      .then(response => {
        if (response.errorcode === '200') {
          const { tagType, uid } = response.resultData
          if (uid && uid !== 'null' && (!tagType || tagType === 'null')) {
            showTagTypeErrorModal('languageObj.nsptagLocale.tagTypeError')
            clearInterval(intervalRef)
            return
          }
          setActualTagType(tagType && tagType !== 'null' ? tagType : '')
          setNfcValue(uid && uid !== 'null' ? uid : '')
        } else {
          setActualTagType('')
          setNfcValue('')
          clearInterval(intervalRef)
          props.showMacError()
        }
      })
      .catch(error => {
        clearInterval(intervalRef)
        props.showMacError()
      })
  }

  const showErrorModal = str => {
    errorModal = modalError(
      {
        content: formatMessageNew(str)
      },
      hideErrorModal
    )
  }

  const hideErrorModal = () => {
    errorModal && destroyModal(errorModal)
    errorModal = null
    resetValues()
  }

  const showTagTypeErrorModal = str => {
    tagTypeErrorModal = modalError(
      {
        content: formatMessageNew(str)
      },
      hideTagTypeErrorModal
    )
  }

  const hideTagTypeErrorModal = () => {
    tagTypeErrorModal && destroyModal(tagTypeErrorModal)
    tagTypeErrorModal = null
    setNfcValue('')
    setActualTagType('')
    resetUidFun()
    openNfcInterval()
  }

  // 全局键盘事件
  const onWindowKeyDown = e => {
    console.log('键盘', e.keyCode)
    if (e.keyCode !== 13) return
    // 关闭 错误提示弹窗
    if (errorModal) hideErrorModal()
    if (tagTypeErrorModal) hideTagTypeErrorModal()
  }

  // UPC 输入框回车事件
  const onInputKeyDownUpc = e => {
    if (e.keyCode !== 13) return
    // 为什么要加这个判断？可能是因为阻止键盘弹起
    inputRef.current.blur()
    onBinding()
  }

  // UPC 输入框聚焦事件
  const onInputFocusUpc = e => {
    setUpcInputReadOnly(true)
    setTimeout(() => {
      setUpcInputReadOnly(false)
    }, 100)

    // setIsBlur(false)
  }

  // NFC 输入框回车事件
  const onInputKeyDownNfc = e => {
    if (e.keyCode !== 13) return
    // 为什么要加这个判断？可能是因为阻止键盘弹起
    inputRef.current.blur()
    onValidationTag()
  }

  // 校验标签是否有效
  const onValidationTag = () => {
    apiTagValidation({ tagUid: nfcValue }, queryHeader)
      .then(res => {
        // 有效
        if (res.errorCode === '200') onBinding()
      })
      .catch(error => {
        // 关闭定时器
        clearInterval(intervalRef)
        let str = ''
        switch (error.errorCode) {
          case '421':
            str = 'languageObj.nsptagLocale.NFCUIDInvalid'
            break
          case '442':
            str = 'languageObj.nsptagLocale.NFCUIDDisabled'
            break
          default:
            str = 'languageObj.nsptagLocale.requestError'
            break
        }
        showErrorModal(str)
      })
  }

  // 绑定
  const onBinding = () => {
    inputRef.current.focus({ cursor: 'all' })
    let paddedUpc = ''
    if (upcValue) {
      paddedUpc = upcValue.length <= 14 ? upcValue.padStart(14, '0') : upcValue
      props.scrollToUpc(paddedUpc)
    }
    if (!upcValue || !nfcValue) return
    // 发送请求前关闭定时器
    props.tagItem(paddedUpc, nfcValue, actualTagType)
  }

  const resetValues = () => {
    clearInterval(intervalRef)
    setUpcValue('')
    setNfcValue('')
    setActualTagType('')
    inputRef.current.focus({ cursor: 'all' })
    openNfcInterval()
    resetUidFun()
  }

  return (
    <div className="h100">
      <Row>
        <Col span={7} style={labelStyle} className="fs-15">
          UPC:
        </Col>
        <Col span={17} className="fs-15">
          <Input
            className="fs-15"
            ref={inputRef}
            value={upcValue}
            allowClear
            readOnly={upcInputReadOnly}
            placeholder={`${formatMessageNew('languageObj.nsptagLocale.pleaseScan')}UPC`}
            onChange={e => handleChange(e, { setState: setUpcValue })}
            onKeyUp={e => onInputKeyDownUpc(e)}
            onFocus={e => onInputFocusUpc(e)}
          />
        </Col>
      </Row>
      <Row className="mt15">
        <Col span={7} style={labelStyle} className="fs-15">
          NFC UID：
        </Col>
        <Col span={17}>
          <Input
            className="fs-15"
            value={nfcValue}
            allowClear
            readOnly
            placeholder={`${formatMessageNew('languageObj.nsptagLocale.pleaseScan')}NFC`}
            onChange={e => handleChange(e, { setState: setNfcValue })}
            onKeyUp={e => onInputKeyDownNfc(e)}
          />
        </Col>
      </Row>
    </div>
  )
})
export default React.memo(ReadTag)
